<template>
    <div class="nimMir">
        <div class="nimMir-inner">
            <h3 class="nimMir_title">{{ form1.isoform_id }}</h3>
            <p class="first_title">Gene information</p>
            <el-form inline class="demo-table-expand">
                <el-row :gutter="30">
                    <el-col :span="8">
                        <el-form-item label="Gene Locus：">
                            <span>{{ form1.gene_id }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Other Name：">
                            <span>{{ form1.Other_Name }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Species：">
                            <span style="font-style: italic;">{{ form1.SpeciesName }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :span="8">
                        <el-form-item label="EC ID：">
                            <span>{{ form1.ec_id }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Chromosome：">
                            <span>{{ form1.Chromesome }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Start：">
                            <span>{{ form1.Start }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :span="8">
                        <el-form-item label="End：">
                            <span>{{ form1.End }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Strand：">
                            <span>{{ form1.Strand }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Exon Number：">
                            <span>{{ form1.Exon_Num }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :span="8">
                        <el-form-item label="Gene Model：">
                            <span>{{ form1.isoform_id }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Interpro ID：">
                            <span>{{ form1.interpro_id }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="KOG ID：">
                            <span>{{ form1.kog_id }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :span="30">
                        <el-form-item label="Reference Genome Version：">
                            <span>{{ form1.Ref_Genome_Version }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Panther ID：">
                    <span v-for="(item, index) in form1.panther_id" :key="index" class="linkSpan" @click="pantherIdJump(item)">{{ item }}</span>
                </el-form-item><br />
                <el-form-item label="GO ID：">
                    <span v-for="(item, index) in form1.GO_ID" :key="index" class="linkSpan" @click="goIdJump(item)">{{ item }}</span>
                </el-form-item><br />
                <el-form-item label="Pfam ID：">
                    <span v-for="(item, index) in form1.pfam_id" :key="index" class="linkSpan" @click="pfamIdJump(item)">{{ item }}</span>
                </el-form-item><br />
                <el-form-item label="KEGG ID：">
                    <span v-for="(item, index) in form1.kegg_id" :key="index" class="linkSpan" @click="keggIdJump">{{ item }}</span>
                </el-form-item><br />
                <el-row :gutter="40">
                    <el-col :span="24">
                        <el-form-item label="Function：">
                            <span>{{ form1.function }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Sequence Information：">
                    <router-link :to="{path: '/detailInfo', query: {id: 'pep_seq', name: 'numMirGene'}}" target="_blank">
                        <span class="linkSpan">Peptide Sequence</span>
                    </router-link>
                    <router-link :to="{path: '/detailInfo', query: {id: 'genomic_seq', name: 'numMirGene'}}" target="_blank">
                        <span class="linkSpan">Transcript Sequence</span>
                    </router-link>
                    <router-link :to="{path: '/detailInfo', query: {id: 'cds_seq', name: 'numMirGene'}}" target="_blank">
                        <span class="linkSpan">CDS Sequence</span>
                    </router-link>
                    <router-link :to="{path: '/JBrowse', query: {data:this.form1.Species,chromesome:this.form1.Chromesome,start:this.form1.Start,end:this.form1.End}}">
                        <span class="linkSpan">JBrowse</span>
                    </router-link>
                    <!-- <router-link :to="{path: '/Eplant', query: {id: 'isJump', data:this.form1.Species}}">
                        <span class="linkSpan">Eplant</span>
                    </router-link> -->
                </el-form-item>
            </el-form>
            <p class="common_title">Map detail image</p>
            <div class="information_div">
                <iframe :src="iframeSrc" width="100%" height="220px">
                </iframe>
            </div>
            <p class="common_title">Expression values
                <i class="el-icon-download" @click="downloadSelect"> Download selected</i>
                <i class="el-icon-download" @click="DownloadAll"> Download all</i>
            </p>
            <el-table :data="tableData" stripe v-loading="loading" :header-cell-style="headerStyle" :row-style="rowStyle" @cell-click="handlecell"
                @selection-change="handleSelectionChange" :cell-style="cellstyle" style="width: 100%">
                <el-table-column v-for="(item, index) in tableDataItem" :width="item.width" :show-overflow-tooltip="true" :key="index" align="center"
                    :prop="item.prop" :label="item.label">
                </el-table-column>
                <el-table-column type="selection" width="55">
                </el-table-column>
            </el-table>
            <div style="text-align:right;margin:20px 0 20px;height:40px;">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
                    :page-sizes="[10, 20, 30, 50]" :page-size="query.size" layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <div style="width:100%;height:200px;position:relative;">
                <!-- <span class="chart1_span1">Color value</span> -->
                <el-form ref="form4" class="form4" :inline="true" :model="form4">
                    <el-form-item label="SRA Study" label-width="100px">
                        <el-select style="width:160px;" size="large" v-model="form4.sra_study" placeholder="Choose" @change="studyChange">
                            <el-option v-for="(item, index) in SRAStudyOptions" :key="index" :label="item.sra_study" :value="item.sra_study">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Development Stage" label-width="166px">
                        <el-select style="width:160px;" size="large" v-model="form4.dev_stage" placeholder="Choose" @change="stageChange">
                            <el-option v-for="(item, index) in DevStageOptions" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Tissue" label-width="80px">
                        <el-select style="width:160px;" size="large" v-model="form4.tissue" placeholder="Choose" @change="tissueChange">
                            <el-option v-for="(item, index) in TissueOptions" :key="index" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <dl class="chart1_dl">
                    <dt>Tissue</dt>
                    <dd v-for="(item, index) in titleItems" :key="index">{{item}}</dd>
                </dl>
                <div style="width:100%;height:200px" ref="chartRl"></div>
                <span class="chart1_span2">SRA Run</span>
            </div>
            <div style="height:300px;width:100%;" ref="barChart"></div>
            <p class="common_title">Regulatory network
                <i class="el-icon-download" @click="toImage"> Download JPEG</i>
                <i class="el-icon-download" @click="downloadTxt"> Download TXT</i>
                <i class="el-icon-download" @click="downloadSif"> Download SIF</i>
            </p>
            <div class="targetNetwork" ref="imageDom">
                <div class="targetNetworkLeft">
                    <dl class='node'>
                        <dt></dt>
                        <dd>Validated lncRNA</dd>
                    </dl>
                    <dl class='node'>
                        <dt></dt>
                        <dd>Predicted lncRNA</dd>
                    </dl>
                    <dl class='node'>
                        <dt></dt>
                        <dd>Gene</dd>
                    </dl>
                    <dl class='node'>
                        <dt></dt>
                        <dd>miRNA</dd>
                    </dl>
                    <dl class='line'>
                        <dt></dt>
                        <dd>Validated Interaction</dd>
                    </dl>
                    <!-- <dl class='line'>
                        <dt></dt>
                        <dd>Positive Correlation</dd>
                    </dl> -->
                    <dl class='line'>
                        <dt></dt>
                        <dd>Predicted Interaction</dd>
                    </dl>
                    <!-- <dl class = 'line'>
                        <dt></dt>
                        <dd>0 - 0.6</dd>
                    </dl>
                    <dl class = 'line'>
                        <dt></dt>
                        <dd>0.6 - 0.9</dd>
                    </dl>
                    <dl class = 'line'>
                        <dt></dt>
                        <dd><i class="el-icon-arrow-right"></i> 0.9</dd>
                    </dl> -->
                </div>
                <div class="targetNetworkRight">
                    <cytoscape v-if='form1.isoform_id' :start_id="form1.isoform_id" :sort='sort' :species="form1.Species"></cytoscape>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import cytoscape from "../cytoscape/index";

let url = {
    detail: "species/gene_detail", // 基因表达数据信息详情展示
    expression_detail: "species/genes_expression_value", // 数据详情信息的展示
    vector_tissue_color: "species/vector_gene_tissue_color", // tissue组织图
    gene_rna_relation: "species/gene_rna_relation", // expression 基因和RNA关系图
    sra_study: "species/plant_gene_sra_study",
    plant_dev_stage: "species/plant_gene_dev_stage", // plant dev_stage下拉框
    plant_tissue: "species/plant_gene_tissue"
};
const echarts = require("echarts");
import html2canvas from 'html2canvas';
import { optionRl, optionGx, optionBar, tableDataItem } from "./config";
export default {

    components: {
        cytoscape
    },

    data() {
        return {
            sort: 'isoform_id',
            optionRl: optionRl,
            optionGx: optionGx,
            optionBar,
            form1: {
                gene_id: "",
                Other_Name: "",
                Species: "",
                SpeciesName: "",
                Ref_Genome_Version: "",
                Chromesome: "",
                Start: "",
                End: "",
                Strand: "",
                Exon_Num: "",
                isoform_id: "",
                interpro_id: "",
                panther_id: "",
                GO_ID: "",
                pfam_id: "",
                kegg_id: "",
                kog_id: "",
                ec_id: "",
                function: ""
            },
            tableDataItem,
            tableData: [],
            query: {
                page: 1,
                size: 10
            },
            total: 0,
            loading: false,
            headerStyle: {
                background: "#F5F9FC",
                fontSize: "16px",
                fontFamily: "PingFang SC",
                fontWeight: "bold",
                color: "#333"
            },
            rowStyle: {
                fontSize: "14px",
                fontFamily: "PingFang SC",
                fontWeight: "400",
                color: "#666"
            },
            titleItems: [],
            iframeSrc: '',
            form4: {
                sra_study: "",
                tissue: "",
                dev_stage: ""
            },
            SRAStudyOptions: [],
            DevStageOptions: [],
            TissueOptions: [],
            limitTitle: 0,
            run_ids: []
        };
    },
    mounted() {
        this.getDetail();
    },
    computed: {

        jbrowseLocStart: function () {
            let lncrnaLength = this.form1.End - this.form1.Start
            if (this.form1.Start - lncrnaLength * 0.5 < 0) {
                return 0
            }
            return this.form1.Start - Math.round(lncrnaLength * 0.5)
        },
        jbrowseLocEnd: function () {
            let lncrnaLength = this.form1.End - this.form1.Start
            return this.form1.End + Math.round(lncrnaLength * 0.5)
        }
    },
    methods: {
        getDetail() {
            let params = { isoform_id: sessionStorage.getItem("isoform_id") };
            this.http.get(url.detail, params).then(res => {
                //   console.log("三层", res);
                if (res.data.code == 200) {
                    this.form1.gene_id = res.data.data[0].gene_id;
                    this.form1.Other_Name = res.data.data[0].other_name;
                    this.form1.Species = res.data.data[0].species;
                    this.form1.SpeciesName = res.data.data[0].species.replace(/_/g, " ");;
                    this.form1.Ref_Genome_Version = res.data.data[0].ref_genome_vers;
                    this.form1.Chromesome = res.data.data[0].chromeSome_scaffold;
                    this.form1.Start = res.data.data[0].start;
                    this.form1.End = res.data.data[0].end;
                    this.form1.Strand = res.data.data[0].strand;
                    this.form1.Exon_Num = res.data.data[0].exon_num;
                    this.form1.isoform_id = res.data.data[0].isoform_id;
                    this.form1.interpro_id = res.data.data[0].interpro_id;
                    this.form1.panther_id = res.data.data[0].panther_id.split(',');
                    this.form1.kog_id = res.data.data[0].kog_id;
                    this.form1.ec_id = res.data.data[0].ec_id;
                    this.form1.GO_ID = res.data.data[0].go_id.split(',')
                    this.form1.pfam_id = res.data.data[0].pfam_id.split(',');
                    this.form1.kegg_id = res.data.data[0].kegg_id.split(',');
                    this.form1.function = res.data.data[0].function;
                    let baseURL = axios.defaults.baseURL.replace('/api', '')
                    this.iframeSrc = `${baseURL}/jb/?data=All_json/${this.form1.Species}&loc=${this.form1.Chromesome}:${this.jbrowseLocStart}..${this.jbrowseLocEnd}&tracks=Gene Locus&highlight=&tracklist=0&nav=0&overview=0`
                    this.expression_detail();
                    this.sra_study();
                    this.plant_dev_stage();
                    this.plant_tissue();
                    this.initCharts();
                }
            }).catch(err => {
                console.log(err);
            });
        },
        expression_detail() {
            let params = {
                species: this.form1.Species,
                isoform_id: sessionStorage.getItem("isoform_id"),
                page: this.query.page,
                size: this.query.size
            };
            this.loading = true
            this.http.get(url.expression_detail, params).then(res => {
                if (res.data.code == 200) {
                    this.tableData = res.data.data;
                    this.total = res.data.count;
                    this.loading = false
                    this.initChartsRl()
                }
            }).catch(err => {
                console.log(err);
            });
        },
        sra_study() {
            this.SRAStudyOptions = [];
            let params = {
                species: this.form1.Species,
                isoform_id: sessionStorage.getItem("isoform_id")
            }
            this.http.get(url.sra_study, params).then(res => {
                if (res.data.code == 200) {
                    this.SRAStudyOptions = res.data.data;
                }
            }).catch(err => {
                this.$message.warning(err.response.data.error.message);
            });
        },
        plant_dev_stage() {
            let params = {
                species: this.form1.Species,
                isoform_id: sessionStorage.getItem("isoform_id")
            };
            this.http.get(url.plant_dev_stage, params).then(res => {
                if (res.data.code == 200) {
                    this.DevStageOptions = res.data.data;
                }
            }).catch(err => {
                console.log(err);
            });
        },
        plant_tissue() {
            let params = {
                species: this.form1.Species,
                isoform_id: sessionStorage.getItem("isoform_id")
            };
            this.http.get(url.plant_tissue, params).then(res => {
                if (res.data.code == 200) {
                    this.TissueOptions = res.data.data;
                }
            }).catch(err => {
                console.log(err);
            });
        },
        studyChange(val) {
            this.initChartsRl()
            this.form4.dev_stage = ''
            if (this.limitTitle > 40) {
                this.form4.dev_stage = this.DevStageOptions[0]
                this.initChartsRl()
            }
        },
        stageChange(val) {
            this.initChartsRl()
            if (this.limitTitle > 40) {
                this.form4.tissue = this.TissueOptions[0]
                this.initChartsRl()
            }
        },
        tissueChange(val) {
            this.initChartsRl()
        },
        handleSizeChange(val) {
            this.query.page = 1
            this.query.size = val
            this.expression_detail()
        },
        handleCurrentChange(val) {
            this.query.page = val
            this.expression_detail()
        },
        initChartsRl() {
            let param = {
                species: this.form1.Species,
                isoform_id: sessionStorage.getItem("isoform_id")
            };
            let params = Object.assign({}, param, this.form4)
            this.http.get(url.vector_tissue_color, params).then(res => {
                //   console.log("三层表格", res);
                if (res.data.code == 200) {
                    this.titleItems = Object.keys(res.data.data[0]);
                    let run_idAll = [];
                    let valueAll = [];
                    let barseriesVal = []
                    Object.values(res.data.data[0]).forEach(items => {
                        items.forEach(item => {
                            run_idAll.push(item.run_id);
                            valueAll.push([item.run_id, 0, item.value]);
                            barseriesVal.push({
                                value: item.value,
                                name: item.dev_stage,
                                tissue: item.tissue
                            });
                        });
                    });

                    // 绘制柱形图
                    let barChart = echarts.init(this.$refs.barChart);
                    this.optionBar.xAxis.data = run_idAll
                    this.optionBar.series[0].data = barseriesVal
                    barChart.setOption(this.optionBar);

                    this.optionRl.xAxis[0].data = run_idAll;
                    this.optionRl.series[0].data = valueAll;
                    this.limitTitle = run_idAll.length
                    if (this.limitTitle > 40) {
                        this.form4.sra_study = this.SRAStudyOptions[0].sra_study
                        this.studyChange()
                    }
                    let myChart = echarts.init(this.$refs.chartRl);
                    // 绘制图表
                    myChart.setOption(this.optionRl);
                }
            }).catch(err => {
                console.log(err);
            });
        },
        // initCharts() {
        //     let params = {
        //         species: this.form1.Species,
        //         start_id: this.form1.gene_id
        //     };
        //     this.http.get(url.gene_rna_relation, params).then(res => {
        //         if (res.data.code == 200) {
        //             // console.log('底部关系图', res.data)
        //             let legendData = []
        //             let Xdata0 = []
        //             let Xdata = []
        //             let links = []
        //             res.data.data.forEach(item => {
        //                 legendData.push({
        //                     name: item.source
        //                 })
        //                 Xdata0.push(item.source)
        //                 if (sessionStorage.getItem("isoform_id") === item.source) {
        //                     Xdata.push({
        //                         name: item.source,
        //                         label: item.other_name,
        //                         symbolSize: 20,
        //                         category: item.source,
        //                         itemStyle: {
        //                             color: item.color,
        //                             borderColor: '#fff',
        //                             borderWidth: 1,
        //                             shadowColor: item.color,
        //                             shadowBlur: 3
        //                             // opacity: 1
        //                             // shadowOffsetX: -10,
        //                             // shadowOffsetY: -10
        //                         }
        //                     })
        //                 } else {
        //                     Xdata.push({
        //                         name: item.source,
        //                         label: item.other_name,
        //                         symbolSize: 20,
        //                         category: item.source,
        //                         itemStyle: {
        //                             color: item.color
        //                         }
        //                     })
        //                 }
        //             })

        //             res.data.data.forEach(item => {
        //                 item.target.forEach(items => {
        //                     links.push({
        //                         source: item.source,
        //                         target: items
        //                     })
        //                 })
        //             })

        //             res.data.data.forEach(item => {
        //                 item.target.forEach(items => {
        //                     // links.push({
        //                     //     source: item.source,
        //                     //     target: items
        //                     // })
        //                     let flag = true
        //                     Xdata.forEach(upMOve => { // 判断点是否有重复的
        //                         if (upMOve.name == items) {
        //                             flag = false
        //                         }
        //                     })
        //                     if (flag) {
        //                         Xdata.push({
        //                             name: items,
        //                             category: item.source
        //                         })
        //                     }
        //                 })
        //             })
        //             // Object.keys(res.data.data[0]).forEach(item => {
        //             //     legendData.push({
        //             //         name: item
        //             //     })
        //             //     Xdata0.push(item)
        //             //     Xdata.push({
        //             //         name: item,
        //             //         symbolSize: 20,
        //             //         category: item
        //             //     })
        //             // })
        //             // Object.keys(res.data.data[0]).forEach(item => {
        //             //     res.data.data[0][item].forEach(items => {
        //             //         links.push({
        //             //             source: item,
        //             //             target: items
        //             //         })
        //             //         let flag = true
        //             //         Xdata.forEach(upMOve => { // 判断点是否有重复的
        //             //             if (upMOve.name == items) {
        //             //                 flag = false
        //             //             }
        //             //         })
        //             //         if (flag) {
        //             //             Xdata.push({
        //             //                 name: items,
        //             //                 category: item
        //             //             })
        //             //         }
        //             //     })
        //             // })
        //             let myChart = echarts.init(this.$refs.chart);
        //             // 绘制图表
        //             // this.optionGx.legend[0].data = legendData
        //             this.optionGx.series[0].data = Xdata
        //             this.optionGx.series[0].categories = legendData
        //             this.optionGx.series[0].links = links
        //             myChart.setOption(this.optionGx);
        //             myChart.on('click', (event) => {
        //                 // 控制台打印数据的名称
        //                 if (event.color === '#2F4554' || event.color === '#ff0000') {
        //                     sessionStorage.removeItem("lncRNA_id");
        //                     sessionStorage.setItem("lncRNA_id", event.name);
        //                     this.$router.push("/nunMir");
        //                 } else if (event.color === '#91C7AE') {

        //                 } else {
        //                     sessionStorage.removeItem("isoform_id");
        //                     sessionStorage.setItem("isoform_id", event.name);
        //                     this.$router.push("/nunMirGene");
        //                     location.reload()
        //                 }
        //             });
        //         }
        //     }).catch(err => {
        //         console.log(err);
        //     });
        // },
        handlecell(row, col) {
            if (col.label === "PMID") {
                window.open(`https://pubmed.ncbi.nlm.nih.gov/${row.pmid}/`, '_blank')
            } else if (col.label == 'SRA Study') {
                window.open(`https://www.ncbi.nlm.nih.gov/sra/?term=${row.sra_study}`, '_blank')
            } else if (col.label == 'SRA Run') {
                window.open(`https://www.ncbi.nlm.nih.gov/sra/?term=${row.run_id}`, '_blank')
            }
        },
        cellstyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 || column.label === 'SRA Study' || column.label === 'SRA Run') {
                return { color: "#3366CC", cursor: "pointer" };
            }
        },
        goIdJump(val) { // 跳转外部链接
            // window.location.href = `https://pubmed.ncbi.nlm.nih.gov/${val}/`
            // window.open(`https://pubmed.ncbi.nlm.nih.gov/${val}/`, '_blank')
            window.open(`http://amigo.geneontology.org/amigo/term/${val}`, '_blank')
        },
        pantherIdJump(val) {
            window.open(`http://www.pantherdb.org/panther/family.do?clsAccession=${val}`, '_blank')
        },
        pfamIdJump(val) {
            window.open(`https://pfam.xfam.org/family/${val}`, '_blank')
        },
        keggIdJump(val) {
            window.open(`https://www.genome.jp/dbget-bin/www_bget?ko:${val}`, '_blank')
        },
        toImage() {
            html2canvas(this.$refs.imageDom, {
                useCORS: true,
                width: this.$refs.imageDom.clientWidth, //canvas宽度
                height: document.body.scrollHeight - this.$refs.imageDom.offsetTop,   //这个高度和windowHeight 的关系调整刚好即可
                windowWidth: this.$refs.imageDom.clientWidth, //获取X轴方向滚动条内容
                windowHeight: this.$refs.imageDom.scrollHeight, //这个高度和height的关系调整刚好即可
                x: 0,
                y: this.$refs.imageDom.offsetTop//页面在垂直方向滚动的距离
            }).then(canvas => {
                var imgData = canvas.toDataURL("image/jpeg");
                this.fileDownload(imgData);
            })
        },
        fileDownload(downloadUrl) {
            let aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.href = downloadUrl;
            aLink.download = "network.jpeg";
            // 触发点击-然后移除
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
        },
        downloadTxt() {
            const param = {
                species: this.form1.Species,
                start_id: this.form1.isoform_id,
                sort: this.sort
            }
            this.jg_downloadFile('species/specie_download_cytoscape_data', param)
        },
        downloadSif() {
            const param = {
                species: this.form1.Species,
                start_id: this.form1.isoform_id,
                sort: this.sort
            }
            this.jg_downloadFile('species/specie_download_sif_cytoscape_data', param)
        },
        //	Expression Value新增下载功能
        handleSelectionChange(val) {
            this.run_ids = []
            val.forEach(item => {
                this.run_ids.push(item.run_id)
            });
        },
        downloadSelect() {
            if (this.run_ids.length < 1) {
                this.$message('Please select the columns to download！')
                return
            }
            const param = {
                species: this.form1.Species,
                isoform_id: this.form1.isoform_id,
                run_id: this.run_ids.join(',')
            }
            this.jg_downloadFile('species/specie_gene_expression_value_download', param)
        },
        DownloadAll() {
            const param = {
                species: this.form1.Species,
                isoform_id: this.form1.isoform_id,
                run_id: ''
            }
            this.jg_downloadFile('species/specie_gene_expression_value_download', param)
        },
    }
};
</script>

<style scoped>
@import "./style.css";
</style>
